import { globals } from 'common-ui';
import { fetchCartWithAtgLegacyApi } from './fetchCartWithAtgLegacyApi';
import { fetchCartWithWebApi } from './fetchCartWithWebApi';

// Function to Fetch the latest cart data
export async function fetchCart(): Promise<void> {
  if (globals.useNewCartAPI) {
    return fetchCartWithWebApi();
  }
  return fetchCartWithAtgLegacyApi();
}
